import { b as buildPaginationParams, n as normalizeToPaginated } from './chunks/pagination-utils-9vQ-Npkr.js';

/**
 * Platform-Agnostic Donation API Client
 *
 * Handles donation operations using the PERS backend.
 * Matches framework DonationApiService methods exactly.
 */
class DonationApi {
    constructor(apiClient) {
        this.apiClient = apiClient;
    }
    // ==========================================
    // PUBLIC OPERATIONS
    // ==========================================
    /**
     * PUBLIC: Get all donation types
     * ✅ ONLY method actually used by framework
     */
    async getAllDonationTypes(options) {
        const params = buildPaginationParams(options);
        const response = await this.apiClient.get(`/purchases/donation-types?${params.toString()}`);
        return normalizeToPaginated(response);
    }
}

/**
 * Platform-Agnostic Donation Service
 *
 * Contains donation business logic and operations that work across platforms.
 * No framework dependencies - pure TypeScript business logic.
 * Matches framework DonationApiService capabilities exactly.
 */
class DonationService {
    constructor(donationApi) {
        this.donationApi = donationApi;
    }
    // ==========================================
    // PUBLIC OPERATIONS
    // ==========================================
    /**
     * PUBLIC: Get all donation types
     * ✅ ONLY method actually used by framework
     */
    async getAllDonationTypes(options) {
        return this.donationApi.getAllDonationTypes(options);
    }
}

export { DonationApi, DonationService };
//# sourceMappingURL=donation.js.map
